import React from "react";
import LogoutTimer from "./LogoutTimer";
import { Navigate } from "react-router-dom";
import { getDecryptedItem } from "../utils/secureStorage";

const ProtectedRoute = ({ children }) => {
  const temp = getDecryptedItem("customerid");

  if (!temp || temp === null || undefined) {
    return <Navigate to={`/auth/sso-login`} />;
  }
  return (
    <>
      {children}
      <LogoutTimer />
    </>
  );
};

export default ProtectedRoute;
